<template>
  <div>
    <NavBar :breadcrumbdata="breadcrumbsinfo" breadcrumbtheme="breadcrumbcss" />
    <section  class="navbarsection">
      <main>
        <div class="videosection">
          <Transition class="transition thing">
            <video-background 
              playbackRate=0.2
              :src="src"
              :poster="poster"
        
              overlay="linear-gradient(to bottom, #003, transparent)" 
              :class="`thing playercss`"
              :style="`height: 556px;`" v-show="pvisvideo === true">
            </video-background>
          </Transition>
          <div id="panorama" class="thing  gradient" v-show="pvisvideo === false && pictureimage === false">
          </div>
          <div v-show="pictureimage === true">
            <img :src="poster" style="height: 70%; margin-bottom: 200px; width: 100%">
          </div>
        </div>
        
        <div class="txtdata">
          <h1 class="rainbow-text" v-html="imagetext"></h1>
        </div>
      </main>
    </section>


      
    <CorpDir :contactdir="contdir" contactdirtheme="contdircss" />


    <section>
      <div class="container bottompagemsg">
        <hr class="hrclass"/>
        <span v-html="aboutgeneral.pdesc" class="hrspantext">

        </span>
      </div>
    </section>
    <section style="height: 40px; padding-bottom: 200px;">
    </section>
    <FooterPage />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterPage from '@/components/FooterPage.vue';
// import StockCards from '@/components/StockCards.vue';
import CorpDir from '@/components/CorpDir.vue';
require('@/globalDeclare.js');
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
// require('@/setup.js');
import axios from 'axios';


export default {
  name: 'AboutView',
  components: {
  NavBar, FooterPage, CorpDir,
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,
  cvdesc: '',
  valuesphotos: [],
  valuesphotosabout: [],
  cvpurposevaluelinkname: '',
  cvlink: '',
  pictureimage: '',

  aboutgeneral: [],
  contdir: [],
  myPicUrl: '',
  }
},
mounted() {
  let showImage = Boolean
  showImage = false
  this.myPicUrl = myUrlPath
axios.get('allpagespv/contact').then(
    response => {
      this.videoimage = response.data

      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
  })
  .catch((error) => {
        console.log(error)
      })
  

    //------------Aboutpage contactinfo ---------------
    axios.get('getcontactdirinfo/').then(
      response => {
          this.contdir = response.data
    })
    .catch((error) => {
        console.log(error)
      })

      //------------All Cards Section---------------
  axios.get('aboutpagegeneral/contact').then(
    response => {
        this.aboutgeneral = response.data
  })
  .catch((error) => {
      console.log(error)
    })
      
}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vendors/bootstrap-vue/_custom.scss";

.valuecardslinkname {
  text-align: center; 
  color: white; 
  font-size: 14px; 
  position: relative; 
  float: right;
}

.secpef {
  margin-top: -300px;
  height: auto;
  margin-bottom: 0px;
  background-color:  #daf1f8;
  padding-top: 60px;
  padding-bottom: 150px;
}
.purposecontainer {
  margin-top: 200px;
  height: 300px;
  margin-bottom: 400px;
  margin-right: auto;
  margin-left: auto;
  width: 70%;
}
.topdiv {
  width: 100%;
}
.middlediv {
  width: 100%;
}

.txtright {
  text-align: right;
}

.container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}

.yearscontainer {
  background-color: grey;
  margin-top: -200px;
 }
.yearscontainergifbtm {
  margin-bottom: 20px;
}
.bottompagemsg{
  font-size: 18px;
  text-align: justify;
  border-top: solid thin grey;
}
.hrspantext {
  padding-top: 10px;
}


.imageswidth {
  max-width: 100%;
}
.picsimages {
  margin-top: -200px;
  width: 100%;
}
.valuedescsec {
  margin-top: 100px;
  background-color: lightgrey;
  height: 500px;
}
.cardcontainer {
  width: 80%;
  height: 400px;
  margin: 0 auto;
  margin-top: 100px;
}
.ourworkmatters {
  color: rgb(44, 102, 177);
  font-size: 40px;
  font-family:fantasy;
}
.formatlinks {
  text-decoration: none;
  font-weight: bold;
  color: rgb(44, 102, 177);
}
.imagescontainer {
  padding-left: 0rem;
  padding-right: 0rem;
  overflow: hidden;
}
.workmattersdesc {
  font-style: italic;
  font-size: 16px;
}
.formatlinksicons {
  font-size: 20px; 
  color: red;
  margin-top: 30px;
}
.contdircss {
  margin-top: 300px;
  color: whitesmoke;
  background-color: whitesmoke;
}

/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .bottompagemsg{
    margin-bottom: -350px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .pantopsection {
    margin-top: -220px;
  }
  .contdircss {
    margin-top: -10px;
  }
  .txtdata {
    margin-bottom: 100px;
    width: 400px;
    padding-right: 10px;
  }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .bottompagemsg{
    margin-bottom: -200px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .txtdata {
    margin-bottom: 200px;
    width: 600px;
    padding-right: 10px;
  }
   .contdircss {
    margin-top: -10px;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .bottompagemsg{
    margin-bottom: -200px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .pantopsection {
    margin-top: -290px;
  }
  .contdircss {
    margin-top: 10px;
  }
  .txtdata {
    margin-bottom: 30px;
    width: 900px;
    padding-right: 10px;
  }
 }


 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .bottompagemsg{
    margin-bottom: -100px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .panimagesize {
    margin-top: 130px;
  }
  .txtdata {
    margin-bottom: 30px;
    width: 900px;
    padding-right: 10px;
  }
 }
 
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .bottompagemsg{
    margin-bottom: -100px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .pantopsection {
    margin-top: -290px;
  }
  
 .txtdata {
  margin-bottom: 100px;
  width: 900px;
  padding-right: 10px;
}
 }
 
 
  
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1400px) {
  .bottompagemsg{
    margin-bottom: -100px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .pantopsection {
    margin-top: -290px;
  }
  .txtdata {
    margin-bottom: 100px;
    width: 900px;
    padding-right: 10px;
  }
  } 

</style>

